import { 
    Box, Button, Checkbox, Dialog, IconButton, MenuItem, 
    Select, Typography, DialogContent, Tooltip, Fab, Divider, Chip, TextField, InputAdornment 
} from "@mui/material";
import { useState } from "react";
import TurnoverData from "./TurnoverData";
import AlerteDialog from "../../AlerteDialog/AlerteDialog";
import AddUpdateTurnover from "../AddUpdate/AddUpdateTurnover";
import { addUpdateTurnover } from "../../../tools/forecast/addUpdateTurnover";
import { useParams } from "react-router";
import getForecastMonthList from "../../../tools/forecast/getForecastMonthList";
import axios from "axios";
import { urlAPI } from "../../../config/config";
import { showSnackbar } from "../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { duplicateTurnover } from "../../../tools/forecast/duplicateTurnover";

// Icons
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';

const Turnover = ({ forecastVersion, forecastDates }: { forecastVersion: number | undefined, forecastDates: string }) => {
    const token = useSelector((state: RootState) => state.user.token);
    const dispatch = useDispatch();
    const params = useParams();

    // Filtres globaux
    const [agency, setAgency] = useState<string>("All");
    const [activeTypes, setActiveTypes] = useState<string[]>(["Tout"]);
    const [searchClient, setSearchClient] = useState<string>("");
    const [searchDetail, setSearchDetail] = useState<string>("");

    // États UI
    const [selectedData, setSelectedData] = useState<string[]>([]);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [showConfirmDialog, setShowConfirmDialog] = useState<boolean>(false);
    const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false);
    const [editId, setEditId] = useState<string>("");

    const [selectedTurnover, setSelectedTurnover] = useState<any>({
        "Régie": [], "Forfait": [], "Hébergement": [], "TMA/TME": [], "TRA": []
    });

    const headers = ["Tout", "Forfait", "Hébergement", "Régie", "TMA/TME", "TRA"];
    const agencies = [
        { label: "Toutes les agences", value: "All" },
        { label: "Agence Nord", value: "Nord" },
        { label: "Agence Sud", value: "Sud" }
    ];

    const monthList = getForecastMonthList(forecastDates);

    const confirmDelete = async () => {
        try {
            const idsToDelete = Object.values(selectedTurnover).flat() as string[];
            await Promise.all(idsToDelete.map(id => 
                axios.delete(`${urlAPI}/forecast/turnover/${id}`, {
                    headers: { Authorization: `Bearer ${token}` }
                })
            ));
            setShowDeleteDialog(false);
            setSelectedData([]);
            setSelectedTurnover({ "Régie": [], "Forfait": [], "Hébergement": [], "TMA/TME": [], "TRA": [] });
            dispatch(showSnackbar("Suppression réussie.", "success"));
        } catch (error) {
            dispatch(showSnackbar("Erreur de suppression.", "error"));
        }
    };

    const handleDuplication = () => {
        if (selectedData.length > 0) {
            duplicateTurnover(selectedData[0], token, setOpenModal, dispatch);
            setSelectedData([]);
        }
    };

    return (
        <Box sx={{ p: 3, bgcolor: "#f8fafc", minHeight: "100vh" }}>
            
            {/* --- BARRE DE FILTRES --- */}
            <Box sx={{ bgcolor: "white", p: 3, borderRadius: 4, mb: 4, border: "1px solid #e2e8f0", boxShadow: "0px 4px 20px rgba(0,0,0,0.03)" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
                    <Typography variant="h5" sx={{ fontWeight: 800, color: "#0f172a" }}>📊 Chiffre d'Affaires</Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        {(searchClient || searchDetail) && (
                            <Button size="small" onClick={() => {setSearchClient(""); setSearchDetail("");}} sx={{textTransform: 'none'}}>Effacer la recherche</Button>
                        )}
                    </Box>
                </Box>

                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, alignItems: "center" }}>
                    <Select 
                        value={agency} 
                        onChange={(e) => setAgency(e.target.value)} 
                        size="small" 
                        sx={{ minWidth: 160, borderRadius: 2, bgcolor: "#f1f5f9", "& fieldset": { border: "none" } }}
                    >
                        {agencies.map((opt, i) => <MenuItem key={i} value={opt.value}>{opt.label}</MenuItem>)}
                    </Select>

                    <Select 
                        multiple 
                        value={activeTypes} 
                        size="small"
                        sx={{ minWidth: 180, borderRadius: 2, bgcolor: "#f1f5f9", "& fieldset": { border: "none" } }}
                        onChange={(e: any) => {
                            const val = e.target.value;
                            if (val.includes("Tout") && !activeTypes.includes("Tout")) setActiveTypes(["Tout"]);
                            else setActiveTypes(val.filter((v:string) => v !== "Tout"));
                        }}
                        renderValue={(selected) => selected.includes("Tout") ? "Tous les types" : `${selected.length} types`}
                    >
                        {headers.map((opt, i) => (
                            <MenuItem key={i} value={opt}><Checkbox checked={activeTypes.includes(opt)} size="small" />{opt}</MenuItem>
                        ))}
                    </Select>

                    <TextField 
                        size="small" 
                        placeholder="Rechercher un client..." 
                        value={searchClient}
                        onChange={(e) => setSearchClient(e.target.value)}
                        sx={{ bgcolor: "#f1f5f9", borderRadius: 2, "& fieldset": { border: "none" }, minWidth: 200 }}
                        InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" color="disabled"/></InputAdornment> }}
                    />

                    <TextField 
                        size="small" 
                        placeholder="Projet ou Collaborateur..." 
                        value={searchDetail}
                        onChange={(e) => setSearchDetail(e.target.value)}
                        sx={{ bgcolor: "#f1f5f9", borderRadius: 2, "& fieldset": { border: "none" }, minWidth: 200 }}
                        InputProps={{ startAdornment: <InputAdornment position="start"><FilterListIcon fontSize="small" color="disabled"/></InputAdornment> }}
                    />

                    <Box sx={{ flexGrow: 1 }} />

                    <Button 
                        variant="contained" 
                        startIcon={<AddCircleIcon />} 
                        onClick={() => { setEditId(""); setOpenModal(true); }}
                        sx={{ borderRadius: 2, textTransform: "none", fontWeight: 700, px: 3 }}
                    >
                        Ajouter
                    </Button>
                </Box>
            </Box>

            {/* --- LISTE DES DONNÉES --- */}
            <Box sx={{ mb: 12 }}>
                {(activeTypes.includes("Tout") ? headers.slice(1) : activeTypes).map((type, index) => (
                    <TurnoverData 
                        key={index} 
                        forecastVersion={forecastVersion} 
                        forecastDates={forecastDates} 
                        type={type} 
                        agency={agency}
                        searchClient={searchClient}
                        searchDetail={searchDetail}
                        setSelectedTurnover={setSelectedTurnover} 
                        openModal={openModal} 
                        showDeleteDialog={showDeleteDialog}
                        setOpenModal={setOpenModal} 
                        setSelectedData={setSelectedData} 
                        selectedData={selectedData} 
                        setEditId={setEditId} 
                    />
                ))}
            </Box>

            {/* --- DOCK FLOTTANT --- */}
            <Box sx={{ 
                position: "fixed", bottom: 30, right: "50%", transform: "translateX(50%)", 
                display: "flex", alignItems: "center", gap: 2, 
                bgcolor: "white", p: "12px 24px", borderRadius: "100px", border: "1px solid #e2e8f0", 
                boxShadow: "0px 10px 40px rgba(0,0,0,0.1)", zIndex: 1100 
            }}>
                <Typography variant="body2" sx={{ fontWeight: 700, mr: 1 }}>{selectedData.length} sélectionnés</Typography>
                <Tooltip title="Supprimer"><Fab color="error" size="small" disabled={selectedData.length === 0} onClick={() => setShowDeleteDialog(true)}><DeleteIcon fontSize="small" /></Fab></Tooltip>
                <Tooltip title="Dupliquer"><Fab color="info" size="small" disabled={selectedData.length !== 1} onClick={handleDuplication} sx={{color: 'white'}}><ContentCopyIcon fontSize="small" /></Fab></Tooltip>
                <Divider orientation="vertical" flexItem />
                <Fab color="primary" size="medium" onClick={() => { setEditId(""); setOpenModal(true); }}><AddCircleIcon /></Fab>
            </Box>

            {/* MODALE */}
            <Dialog open={openModal} fullWidth maxWidth="lg" PaperProps={{ sx: { borderRadius: 4 } }}>
                <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #eee' }}>
                    <Typography variant="h6" sx={{fontWeight: 800}}>{editId ? "Modifier" : "Ajouter"} une prestation</Typography>
                    <IconButton onClick={() => setShowConfirmDialog(true)}><CloseIcon /></IconButton>
                </Box>
                <DialogContent sx={{ p: 0 }}>
                    <AddUpdateTurnover turnoverId={editId} handleSubmit={addUpdateTurnover} forecastId={params.id} version={forecastVersion} setOpenModal={setOpenModal} monthList={monthList} monthlyAmount={10} />
                </DialogContent>
            </Dialog>

            <AlerteDialog open={showConfirmDialog} handleClose={() => setShowConfirmDialog(false)} deleteProject={() => { setShowConfirmDialog(false); setOpenModal(false); setEditId(""); }} title="Abandonner ?" contentText="Modifications non enregistrées." color="error" />
            <AlerteDialog open={showDeleteDialog} handleClose={() => setShowDeleteDialog(false)} deleteProject={confirmDelete} title="Supprimer ?" contentText="Cette action est irréversible." color="error" />
        </Box>
    );
};

export default Turnover;